module.exports = __webpack_public_path__ + "img/mild.be5030ca.webp";